import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

const DownloadExcelButton = ({ buildFilters }) => {
    const handleDownload = async () => {
        try {
            const token = localStorage.getItem("token");
            const params = buildFilters();

            const queryString = new URLSearchParams(params).toString();

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/placements/download/excel?${queryString}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to download Excel");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            const formatDate = () => {
                const date = new Date();
                const day = String(date.getDate()).padStart(2, "0");
                const month = date.toLocaleString("en-GB", { month: "short" }).toLowerCase();
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            };

            link.download = `Placements_${formatDate()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Excel download error:", error);
            alert("Failed to download Excel file");
        }
    };

    return (
        <button
            className="download-btn"
            onClick={handleDownload}
            title="Download Excel"
        >
            <FontAwesomeIcon icon={faFileExcel} />
        </button>
    );
};

export default DownloadExcelButton;
